module.exports = __webpack_public_path__ + "static/media/Klavika_Medium.f9dd8ee8.woff";